import React, { useEffect } from 'react';

const Maintenance = () => {
    useEffect(() => {
        // Dynamically import CSS only for maintenance mode
        import("../Styles/Maintenance.css");
        
        // Cleanup function to remove styles when component unmounts
        return () => {
            // Remove maintenance styles when leaving the page
            const styleSheets = document.styleSheets;
            for (let i = styleSheets.length - 1; i >= 0; i--) {
                const sheet = styleSheets[i];
                if (sheet.href && sheet.href.includes('Maintenance.css')) {
                    sheet.disabled = true;
                }
            }
        };
    }, []);
    function switchLanguage(lang) {
        const svContent = document.getElementById('content-sv');
        const enContent = document.getElementById('content-en');
        const svBtn = document.getElementById('btn-sv');
        const enBtn = document.getElementById('btn-en');

        if (lang === 'sv') {
            svContent.classList.remove('hidden');
            enContent.classList.add('hidden');
            svBtn.classList.add('active');
            enBtn.classList.remove('active');
            document.documentElement.lang = 'sv';
        } else {
            svContent.classList.add('hidden');
            enContent.classList.remove('hidden');
            svBtn.classList.remove('active');
            enBtn.classList.add('active');
            document.documentElement.lang = 'en';
        }
    }

    return (
        <>
            <style>

            </style>
            <div class="container">
                <div class="logo">
                    <img src="introteknik_logo_text.png" alt="Introteknik AB Logo" />
                </div>

                <div class="content" id="content-sv">
                    <h2>🚧 Webbplatsen är under konstruktion 🚧</h2>
                    <p class="subtitle">Vi arbetar för att ge dig en bättre upplevelse</p>

                    <div class="info-box">
                        <h3>Om Oss</h3>
                        <p>Introteknik är återförsäljare av industrifärg och levererar högkvalitativa lösningar för dina behov.</p>
                    </div>

                    <div class="contact-box">
                        <h3>Kontakta Oss</h3>
                        <p><strong>Lars Kjellberg</strong></p>
                        <p>📞 <a href="tel:+46708879879">+46 708 87 98 79</a></p>
                        <p>✉️ <a href="mailto:lars.kjellberg@introteknik.se">lars.kjellberg@introteknik.se</a></p>
                    </div>
                </div>

                <div class="content hidden" id="content-en">
                    <h2>🚧 Website Under Construction 🚧</h2>
                    <p class="subtitle">We are working to bring you a better experience</p>

                    <div class="info-box">
                        <h3>About Us</h3>
                        <p>Introteknik is an industrial paint retailer providing high-quality solutions for your needs.</p>
                    </div>

                    <div class="contact-box">
                        <h3>Contact Us</h3>
                        <p><strong>Lars Kjellberg</strong></p>
                        <p>📞 <a href="tel:+46708879879">+46 708 87 98 79</a></p>
                        <p>✉️ <a href="mailto:lars.kjellberg@introteknik.se">lars.kjellberg@introteknik.se</a></p>
                    </div>
                </div>

                <div class="language-toggle">
                    <button id="btn-sv" class="active" onClick={() => switchLanguage('sv')}>Svenska</button>
                    <button id="btn-en" onClick={() => switchLanguage('en')}>English</button>
                </div>

                <footer>
                    <p>&copy; 2026 Introteknik. Alla rättigheter förbehållna / All rights reserved.</p>
                </footer>
            </div>
        </>
    );
};

export default Maintenance;
